import styled from 'styled-components';
import colors from '../../../helpers/colors';
import spacing from '../../../helpers/spacing';
import { Grid, GridItem } from '../../Grid';
import RichText from '../../RichText';

export const DesktopGrid = styled(Grid)`
  display: flex;
`;

export const Panel = styled(GridItem)`
  background: ${colors.neutral08};
`;

export const PanelButtonContainer = styled(GridItem)`
  display: flex;
  align-items: flex-end;
  border-bottom: solid 1px ${colors.neutral03};
  background: ${colors.neutral08};
`;

export const DesktopGridItem = styled(GridItem)`
  padding: ${spacing(3)} 0;
  margin: 0;
`;

export const PanelRichText = styled(RichText)``;
